/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Network_FavoritesInputs */

const fr_map_network_favorites = /** @type {(inputs: Map_Network_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réseaux favoris`)
};

const en_map_network_favorites = /** @type {(inputs: Map_Network_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favorite networks`)
};

/**
* | output |
* | --- |
* | "Favorite networks" |
*
* @param {Map_Network_FavoritesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_network_favorites = /** @type {((inputs?: Map_Network_FavoritesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Network_FavoritesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_network_favorites(inputs)
	return en_map_network_favorites(inputs)
});